export const LOCATION_CHANGED = 'LOCATION_CHANGED'

export const locationChanged = prevLocation => dispatch => {
  dispatch({
    type: LOCATION_CHANGED,
    payload: prevLocation,
  })
}
